export const onCreateLikiee = /* GraphQL */ `
  subscription onCreateLikiee {
    onCreateLikiee {
      id
      availability
      isEnhancingInProgress
      isVisualMatchesInProgress
      item {
        id
        url
        title
        description
        size
        sku
        upc
        gtin
        color
        brand
        model
        itemSourceId
        canonicalUrl
        additionalProperty
        aggregateRating
        descriptionHtml
        breadcrumbs
        mainImage
        probability
        updatedAt
      }
      source {
        url
        name
        faviconURL
      }
      projects {
        items {
          id
        }
      }
      thumbnailURLs
      images
      status
      url
      imageURL
      price
      originalPrice
      priceTrend
      priceRange {
        min
        max
        currency
        count
      }
      currency
      breadcrumbs
      description
      name
      createdAt
      priceAlert {
        likieeId
        originalPrice
        alertPriceMin
        id
      }
      priceAlertId
      updatedAt
      locale
    }
  }
`;

export const onUpdateLikiee = /* GraphQL */ `
  subscription onUpdateLikiee {
    onUpdateLikiee {
      id
      availability
      isEnhancingInProgress
      isVisualMatchesInProgress
      item {
        features
        id
        url
        title
        description
        size
        sku
        upc
        gtin
        color
        brand
        model
        itemSourceId
        canonicalUrl
        additionalProperty
        aggregateRating
        descriptionHtml
        breadcrumbs
        mainImage
        probability
        updatedAt
      }
      source {
        url
        name
        faviconURL
      }
      projects {
        items {
          id
          name
          icon
          visibility
          visibilityGroup
          itemsCount
          createdAt
          updatedAt
        }
      }
      thumbnailURLs
      images
      status
      url
      affiliateURL
      imageURL
      price
      originalPrice
      priceTrend
      currency
      priceRange {
        min
        max
        currency
        count
      }
      breadcrumbs
      description
      name
      createdAt
      features
      priceAlert {
        alertWhenGetsCheaper
        likieeId
        originalPrice
        alertPriceMin
        checkInterval
        id
      }
      aiSummary {
        categoryInsights
        confidenceScore
        dataCompleteness
        generatedAt
        highlights
        imageType
        keyFeatures
        modelVersion
        primaryCategory
        searchableAttributes {
          ageGroup
          allergens
          availableColors
          availableSizes
          certifications
          compatibility
          ecoLabels
          ingredients
          materials
          restrictions
          skillLevel
          warnings
        }
        targetAudience
        useCases
      }
      visualMatches {
        matches {
          link
          source
          thumbnail
          title
          source_icon
          position
          original_url
          price {
            currency
            extracted_value
            value
          }
        }
        locale
        country
        searchType
        searchImage
        searchTerm
        searchCategory
      }
      historicalPrices {
        availability
        currency
        currencyRaw
        date
        price
        regularPrice
      }
      priceAlertId
      updatedAt
      aiSummary {
        generatedAt
        modelVersion
        primaryCategory
        highlights
        keyFeatures
        targetAudience
        useCases
        searchableAttributes {
          allergens
          ingredients
          materials
          certifications
          ecoLabels
          compatibility
          ageGroup
          skillLevel
          warnings
          restrictions
          availableSizes
          availableColors
        }
        categoryInsights
        confidenceScore
        dataCompleteness
      }
      aiEnhancement {
        imageUrl
        processingTime
      }
      reviewsAggregation {
        lastUpdated
        totalReviews
        reviewSources
        averageRating
        ratingDistribution {
          fiveStar
          fourStar
          threeStar
          twoStar
          oneStar
        }
        summary {
          topPositives
          topNegatives
          frequentMentions
          commonUseCases
        }
        sentimentScore {
          positive
          neutral
          negative
        }
        trendingTopics {
          topic
          sentiment
          mentionCount
        }
        detailedInsights
      }
    }
  }
`;

export const onDeleteLikiee = /* GraphQL */ `
  subscription onDeleteLikiee {
    onDeleteLikiee {
      id
    }
  }
`;
